<template>
  <div class="content">
    <div class="form luc-hao">
      <div class="form-group cach-lap-que">
        <p>
          <input type="radio" id="test1" value="1" v-model="cachlapque">
          <label for="test1" :class="{'active': isGieoQue}">Gieo quẻ</label>
        </p>
        <p>
          <input type="radio" id="test2" value="0" v-model="cachlapque">
          <label for="test2" :class="{'active': !isGieoQue}">Số seri tiền</label>
        </p>
      </div>

      <template v-if="isGieoQue">
        <div class="form-group gio-sinh">
          <label>Việc cần xem</label>
          <select class="form-control" v-model="typeXem">
            <option
              v-for="(value, index) in typeXems"
              :key="index"
              :value="index + 1"
            >
              {{ value }}
            </option>
          </select>
        </div>
        <div class="form-group gio-sinh" :style="`display: ${isOther ? 'flex': 'none'}`">
          <label></label>
          <input class="form-control" style="width: 70%;" v-model="viecCanXem" >
        </div>

        <div class="flex">
          <div class="form-group">
            <label>Ngày (DL)</label>
            <select class="form-control" v-model="day">
              <option
                v-for="(value, index) in days"
                :key="index"
                :value="index + 1"
              >
                {{ value + 1 }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Tháng (DL)</label>
            <select class="form-control" v-model="month">
              <option
                v-for="(value, index) in months"
                :key="index"
                :value="index + 1"
              >
                {{ value + 1 }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Năm (DL)</label>
            <select class="form-control" v-model="year">
              <option
                v-for="(value, index) in years"
                :key="index"
                :value="value"
              >
                {{ value }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Giờ lập (24h)</label>
            <select class="form-control" v-model="hour">
              <option
                v-for="(value, index) in hours"
                :key="index"
                :value="value"
              >
                {{ value + 1 }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-group gio-sinh dong-cuc">
          <label style="margin: 0">An vòng TS</label>
          <p style="margin-right: 10px">
            <input type="radio" id="test3" value="1" v-model="dongcuc">
            <label for="test3" :class="{'active': isHoaTho}">Hỏa Thổ đồng cục</label>
          </p>
          <p>
            <input type="radio" id="test4" value="0" v-model="dongcuc">
            <label for="test4" :class="{'active': !isHoaTho}">Thủy Thổ đồng cục</label>
          </p>
        </div>

        <table class="table-auto">
          <thead>
          <tr>
            <th>Lần gieo</th>
            <th>Hào</th>
            <th>Âm Dương</th>
            <th style="text-align: center">Động</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(value, index) in data" :key="index">
            <td>Lần {{ value.index }}</td>
            <td>
              {{ value.hao }}
            </td>
            <td>
              <select class="form-control" v-model="value.amduong">
                <option
                  v-for="(amduong, index) in amduongs"
                  :key="index"
                  :value="amduong.value"
                >
                  {{ amduong.text }}
                </option>
              </select>
            </td>
            <td style="text-align: center">
              <input type="checkbox" name="dong" v-model="value.dong">
            </td>
          </tr>
          </tbody>
        </table>
      </template>

      <template v-else>
        <div class="form-group gio-sinh">
          <label>Việc cần xem</label>
          <select class="form-control" v-model="typeXem">
            <option
              v-for="(value, index) in typeXems"
              :key="index"
              :value="index + 1"
            >
              {{ value }}
            </option>
          </select>
        </div>
        <div class="form-group gio-sinh" :style="`display: ${isOther ? 'flex': 'none'}`">
          <label></label>
          <input class="form-control" style="width: 70%;" v-model="viecCanXem" >
        </div>

        <div class="flex">
          <div class="form-group">
            <label>Ngày (DL)</label>
            <select class="form-control" v-model="day">
              <option
                v-for="(value, index) in days"
                :key="index"
                :value="index + 1"
              >
                {{ value + 1 }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Tháng (DL)</label>
            <select class="form-control" v-model="month">
              <option
                v-for="(value, index) in months"
                :key="index"
                :value="index + 1"
              >
                {{ value + 1 }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Năm (DL)</label>
            <select class="form-control" v-model="year">
              <option
                v-for="(value, index) in years"
                :key="index"
                :value="value"
              >
                {{ value }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Giờ lập (24h)</label>
            <select class="form-control" v-model="hour">
              <option
                v-for="(value, index) in hours"
                :key="index"
                :value="value"
              >
                {{ value + 1 }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-group gio-sinh dong-cuc">
          <label style="margin: 0">An vòng TS</label>
          <p style="margin-right: 10px">
            <input type="radio" id="test5" value="1" v-model="dongcuc">
            <label for="test5" :class="{'active': isHoaTho}">Hỏa Thổ đồng cục</label>
          </p>
          <p>
            <input type="radio" id="test6" value="0" v-model="dongcuc">
            <label for="test6" :class="{'active': !isHoaTho}">Thủy Thổ đồng cục</label>
          </p>
        </div>

        <div class="form-group gio-sinh">
          <label>Nhập số seri</label>
          <input class="form-control" style="width: 70%;" v-model="seri">
        </div>

      </template>

      <div style="margin-top: 20px">
        <button class="btn" @click="onSubmit">Gửi</button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'FormInput',
  data () {
    return {
      cachlapque: 1,
      dongcuc: 1,
      hours: [...Array(24).keys()],
      days: [...Array(31).keys()],
      months: [...Array(12).keys()],
      years: Array.from({ length: 76 }, (_, i) => i + 1955),
      typeXems: [
        'Cầu tài',
        'Cầu quan',
        'Cầu tự',
        'Thi cử',
        'Mồ mả',
        'Bệnh tật',
        'Hôn nhân',
        'Nhà cửa',
        'Ma quỷ',
        'Other'
      ],
      viecCanXem: null,
      seri: null,
      amduongs: [
        {
          value: 1,
          text: '———'
        },
        {
          value: 0,
          text: '—　—'
        }
      ],
      typeXem: null,
      year: moment().format('YYYY'),
      month: moment().format('M'),
      day: moment().format('D'),
      hour: moment().format('H'),
      data: [
        {
          key: 1,
          index: 6,
          hao: 'Hào Thượng',
          amduong: 1,
          dong: false
        },
        {
          key: 2,
          index: 5,
          hao: 'Hào Ngũ',
          amduong: 1,
          dong: false
        },
        {
          key: 3,
          index: 4,
          hao: 'Hào Tứ',
          amduong: 1,
          dong: false
        },
        {
          key: 4,
          index: 3,
          hao: 'Hào Tam',
          amduong: 1,
          dong: false
        },
        {
          key: 5,
          index: 2,
          hao: 'Hào Nhị',
          amduong: 1,
          dong: false
        },
        {
          key: 6,
          index: 1,
          hao: 'Hào Sơ',
          amduong: 1,
          dong: false
        }
      ]
    }
  },
  computed: {
    isGieoQue () {
      return this.cachlapque.toString() === '1'
    },
    isHoaTho () {
      return this.dongcuc.toString() === '1'
    },
    isOther () {
      return this.typeXem && this.typeXem === 10
    }
  },
  methods: {
    onSubmit () {
      const data = {
        typeXem: this.isOther ? this.viecCanXem : (this.typeXems[this.typeXem - 1] || this.typeXems[0]),
        day: this.day,
        month: this.month,
        year: this.year,
        hour: this.hour,
        gieoque: this.data,
        seri: this.seri ?? '11111111',
        cachlapque: this.cachlapque,
        isGieoQue: this.isGieoQue,
        isHoaTho: this.isHoaTho
      }
      this.$emit('input', data)
    }
  }
}
</script>
<style scoped>
  input[type=checkbox]
  {
    /* Double-sized Checkboxes */
    -ms-transform: scale(2); /* IE */
    -moz-transform: scale(2); /* FF */
    -webkit-transform: scale(2); /* Safari and Chrome */
    -o-transform: scale(2); /* Opera */
    transform: scale(2);
    padding: 10px;
  }
  .flex {
    display: flex;
  }
  .flex .form-group{
     width: 25%;
   }
  table {
    width: 100%;
    text-align: left;
  }
  table th, table td {
    padding: 0 20px;
  }
  table td label{
    width: 20px;
  }
  table .form-control {
    font-size: 25px;
    font-weight: bold;
    background-color: transparent;
    padding: 0;
  }
  table select option {
    font-weight: bold;
  }

  .cach-lap-que {
    text-align: center !important;
    font-size: 18px;
    margin-bottom: 0 !important;
  }

  .dong-cuc {
    border-bottom: 1px solid #07756163;
  }

  .cach-lap-que label.active, .dong-cuc label.active {
    color: #333333 !important;
  }
  @media only screen and (max-width: 800px) {
    table th, table td {
      padding: 0 0;
    }
  }
  @media only screen and (max-width: 320px) {
    .content {
      font-size: 13px;
    }
    .form-control {
      padding: 0;
    }
  }
</style>
